//@flow
import * as React from 'react';
import { connect } from 'react-redux';
import queryString from 'query-string';

//Phoenix React Lib Components
import ContainerRowSpace from '@lesofi/phoenix-react-js/lib/ContainerRowSpace'
import ContainerRowTitle from '@lesofi/phoenix-react-js/lib/ContainerRowTitle'
import ContainerRowError from '@lesofi/phoenix-react-js/lib/ContainerRowError'
import ContainerRowInstructionLink from '@lesofi/phoenix-react-js/lib/ContainerRowInstructionLink'

import InvoiceHeaderContainer from './InvoiceHeaderContainer'
import LineItemsContainer from './LineItemsContainer'

const InvoiceDataExtractionForm = props => {
    const { location,athena } = props;
    const query = queryString.parse(location.search);
    
    if (!query.jwt || !query.docUrl || !query.taskAcceptedInfoId ) {
        return (
            <div className="container">
               <ContainerRowSpace />
               <ContainerRowTitle title={'Invoice Data Extraction'} />
               <ContainerRowError errorMsg={'Missing Parameters!'} /> 
            </div>
        )
    }
    
    return (
        <div className="container">
            <ContainerRowSpace />
            <ContainerRowTitle title={'Invoice Data Extraction'} />
            <ContainerRowInstructionLink docLink={query.docUrl} instructionLink={'https://docs.google.com/document/d/e/2PACX-1vRqHiTUHXlX7EGAqzsjisiDz014r_x0V8l6fLbxBpjYHLxgfm4dpBRry6cAbSarA7sRmjZFPG5PQOCG/pub?embedded=true'} />
            <InvoiceHeaderContainer query={query}/>
            <LineItemsContainer
                isTriggerAddLineItem={athena.addEditLineItem}
                jwt={query.jwt}
                taskAcceptedInfoId={query.taskAcceptedInfoId}
            />
        </div>
    )
}

const mapStateToProps = (state, ownProps) => {
    return {
        athena: state.athena
    }
}

export default connect(mapStateToProps)(InvoiceDataExtractionForm);


// WEBPACK FOOTER //
// ./src/views/projectAthena/InvoiceDataExtractionForm.js